// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuetify from 'vuetify'
import './stylus/main.styl'
import '@mdi/font/css/materialdesignicons.css'
import VueEvents from 'vue-events'
import Vue2Filters from 'vue2-filters'
import Vuelidate from 'vuelidate'
import VueNumeric from 'vue-numeric'
import VueNumericInput from 'vue-numeric-input'
import BlockUI from 'vue-blockui'
import CKEditor from '@ckeditor/ckeditor5-vue'
import Snotify, { SnotifyPosition } from 'vue-snotify/vue-snotify.min.js'
import 'vue-snotify/styles/material.css'
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import App from './App'
import store from './store'
import router from './router'
import { api, formatMediumDate, formatShortDate, statusBgColor } from './filters'
const vueConfig = require('vue-config')
const configs = {
  serverURI: '/api'
}
Vue.use(Vuetify)
Vue.use(vueConfig, configs)
Vue.config.productionTip = false
Vue.use(Vue2Filters)
Vue.use(VueEvents)
Vue.use(Vuelidate)
Vue.use(VueNumeric)
Vue.use(VueNumericInput)
Vue.use(BlockUI)
Vue.use(Snotify, {
  toast: {
    position: SnotifyPosition.centerTop,
    timeout: 2000,
    showProgressBar: false,
    closeOnClick: true,
    pauseOnHover: false
  }
})
Vue.use( CKEditor )
Vue.use(VueQuillEditor)
Vue.use(Vuetify, {
  iconfont: 'mdi'
})

Vue.filter('api', api)
Vue.filter('formatMediumDate', formatMediumDate)
Vue.filter('formatShortDate', formatShortDate)
Vue.filter('statusBgColor', statusBgColor)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js